<template>
  <div class="has-fixed-page-subheader">
    <div class="page-subheader d-flex">
      <div class="page-subheader-content d-flex text-center align-self-center">
        <span class="  text-center align-self-center">
          Kudos
        </span>
        <router-link
          :to="`/customerView/${customerId}`"
          class="back-to-dashboard-link   text-center align-self-center"
        >
          Back to Dashboard
        </router-link>
      </div>
    </div>
    <v-skeleton-loader class="mx-auto ml-2 mr-2" type="card" :loading="loading">
      <v-card elevation="0">
        <v-card-text>
          <!-- Start Kudos section -->
          <v-data-table
            :headers="headers"
            :items="records"
            item-key="id"
            :loading="isLoading"
            :server-items-length="totalRecords"
            :options.sync="options"
            loading-text="Loading... Please wait"
            class="elevation-1 styled-table"
          >
            <template #[`item.kudosDate`]="{ item }">
              {{ formatDateUs(item.kudosDate) }}
            </template>
          </v-data-table>

          <!-- End Documents section -->
        </v-card-text>
      </v-card>
      <!-- </v-container> -->
    </v-skeleton-loader>
  </div>
</template>

<script>
// import CommunityInfo from "@/view/components/CommunityInfo.vue";
// import InternalBreadcrumbs from "@/view/components/DashboardInternalBreadcrumbs.vue";
import { GET_PAGED, API_KUDOS } from "@/core/store/crud.module";
// import crud from "@/core/helpers/crud";
// import { API_USERS } from "@/core/store/crud.module";
import dateFormatter from "@/core/helpers/dateFormatter";
import stringFormatter from "@/core/helpers/stringFormatter";
import { validationMixin } from "vuelidate";

// import { required } from "vuelidate/lib/validators";
// import moment from "moment";
// import permissionsHelper from "@/core/helpers/permissionsHelper";

export default {
  mixins: [validationMixin],
  components: {
    // CommunityInfo,
    // InternalBreadcrumbs
  },
  data: () => ({
    headers: [
      { text: "Community Name", value: "communityName", class: "orange-bg" },
      { text: "From", value: "from", class: "orange-bg" },
      { text: "Message", value: "body", class: "orange-bg" },
      { text: "Kudos Date", value: "kudosDate", class: "orange-bg" }
    ],
    communityInfo: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ["kudosDate"],
      sortDesc: [true]
    },

    isLoading: false,
    loading: false,
    snackbarContent: "",
    snackbarColor: "#F06835",
    breadcrumbs: [],
    records: [],
    totalRecords: 0,

    permissions: {},
    mounted: false
  }),
  props: {
    customerId: {
      type: [Number, String],
      default: 0
    }
  },
  validations() {
    return true;
    // return {
    //   billingInfo: {
    //     subscription: {
    //       nextBillingDates: {
    //         required,
    //         minDate: value =>
    //           dateFormatter.convertToMilliseconds(value) >
    //           dateFormatter.convertToMilliseconds(new Date())
    //       }
    //     }
    //   }
    // };
  },
  watch: {
    // options: async function() {
    //   this.isLoading = true;
    //   if (this.previousPage < this.options.page && this.options.page !== 1) {
    //     this.setStartingAfter();
    //   } else if (
    //     this.previousPage > this.options.page &&
    //     this.options.page !== 1
    //   ) {
    //     this.setEndingBefore();
    //   } else {
    //     this.startingAfter = "";
    //     this.endingBefore = "";
    //   }
    //   this.isLoading = false;
    // }
    options: async function() {
      if(!this.mounted) return;
      await this.getRecords();
    }
  },
  async mounted() {
    this.mounted = false;
    await this.getRecords();
    this.mounted = true;
  },
  async created() {
    // permissionsHelper.getPermissions().then(this.getPermissions);
    // await this.getComunityInfo();
  },
  methods: {
    // getPermissions(permissionsObj) {
    //   this.permissions = permissionsObj;
    // },
    // showRelatedCommunity(communityId) {
    //   this.$router.push({
    //     name: "CustomerDetails",
    //     params: { customerId: communityId }
    //   });
    // },

    async getRecords() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.isLoading = true;

      let self = this;
      let url = `${API_KUDOS}`;

      await this.$store
        .dispatch(GET_PAGED, {
          listName: url,
          params: {
            propertyId: this.customerId
          }
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            let items = response.data.$values;

            if (sortBy.length === 1 && sortDesc.length === 1) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy[0]];
                const sortB = b[sortBy[0]];

                if (sortDesc[0]) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            if (itemsPerPage > 0) {
              items = items.slice(
                (page - 1) * itemsPerPage,
                page * itemsPerPage
              );
            }

            self.records = items;
            self.totalRecords = self.records.length;
          } else {
            self.$snackbar.showMessage({
              content:
                response.data || "Cannot receive Kudos. Something went wrong!",
              color: "red"
            });
          }

          self.isLoading = false;
        });
    },

    formatDate(date) {
      return dateFormatter.formatEditDate(date);
    },
    formatDateUs(date) {
      // return moment.utc(date).format("MM/DD/YYYY");
      return dateFormatter.formatDateUs(date);
    },
    capitalizeFirstLetter(string) {
      return stringFormatter.capitalizeFirstLetter(string);
    }
  },
  computed: {}
};
</script>
